var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-start"},_vm._l((_vm.categories),function(category){return _c('router-link',{key:category.id,staticClass:"navbar-item",attrs:{"to":category.url},nativeOn:{"click":function($event){return _vm.setMobileMenu(false)}}},[_vm._v(" "+_vm._s(category.title)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }